import React from 'react';
import './LegalPages.css';

const Imprint = () => {
  return (
    <div className="legal-page">
      <div className="container">
        <div className="legal-header">
          <h1>Impressum</h1>
          <p>Angaben gemäß § 5 TMG</p>
        </div>

        <div className="legal-content">
          <section className="legal-section">
            <h2>Angaben zum Verein</h2>
            <p>
              <strong>EFC Buseck e.V.</strong><br/>
              Eintracht Frankfurt Fanclub<br/>
              Hauptstraße 42<br/>
              35418 Buseck<br/>
              Deutschland
            </p>
          </section>

          <section className="legal-section">
            <h2>Kontakt</h2>
            <p>
              <strong>Telefon:</strong> +49 (0) 6408 123456<br/>
              <strong>E-Mail:</strong> info@efc-buseck.de<br/>
              <strong>Website:</strong> www.efc-buseck.de
            </p>
          </section>

          <section className="legal-section">
            <h2>Vereinsregister</h2>
            <p>
              <strong>Registergericht:</strong> Amtsgericht Gießen<br/>
              <strong>Registernummer:</strong> VR 12345<br/>
              <strong>Vereinsregister-Eintrag:</strong> Eingetragen am 15.03.2015
            </p>
          </section>

          <section className="legal-section">
            <h2>Vertretungsberechtigte Vorstände</h2>
            <p>
              <strong>1. Vorsitzender:</strong> Michael Weber<br/>
              <strong>2. Vorsitzende:</strong> Anna Schmidt<br/>
              <strong>Kassenwart:</strong> Peter Klein<br/>
              <strong>Schriftführerin:</strong> Sandra Müller
            </p>
            <p>
              Der Verein wird durch den 1. oder 2. Vorsitzenden allein vertreten.
            </p>
          </section>

          <section className="legal-section">
            <h2>Steuernummer</h2>
            <p>
              <strong>Steuernummer:</strong> 20/250/12345<br/>
              <strong>Finanzamt:</strong> Gießen<br/>
              <strong>Gemeinnützigkeit:</strong> Anerkannt als gemeinnütziger Verein zur Förderung des Sports
            </p>
          </section>

          <section className="legal-section">
            <h2>Aufsichtsbehörde</h2>
            <p>
              Zuständige Aufsichtsbehörde für Vereine:<br/>
              <strong>Amtsgericht Gießen</strong><br/>
              Ostanlage 20<br/>
              35390 Gießen<br/>
              Deutschland
            </p>
          </section>

          <section className="legal-section">
            <h2>Haftungsausschluss</h2>

            <h3>Inhalt des Onlineangebotes</h3>
            <p>
              Der Autor übernimmt keinerlei Gewähr für die Aktualität, Korrektheit, Vollständigkeit oder 
              Qualität der bereitgestellten Informationen. Haftungsansprüche gegen den Autor, welche sich 
              auf Schäden materieller oder ideeller Art beziehen, die durch die Nutzung oder Nichtnutzung 
              der dargebotenen Informationen bzw. durch die Nutzung fehlerhafter und unvollständiger 
              Informationen verursacht wurden, sind grundsätzlich ausgeschlossen, sofern seitens des 
              Autors kein nachweislich vorsätzliches oder grob fahrlässiges Verschulden vorliegt.
            </p>

            <h3>Verweise und Links</h3>
            <p>
              Bei direkten oder indirekten Verweisen auf fremde Internetseiten ("Links"), die außerhalb 
              des Verantwortungsbereiches des Autors liegen, würde eine Haftungsverpflichtung ausschließlich 
              in dem Fall in Kraft treten, in dem der Autor von den Inhalten Kenntnis hat und es ihm technisch 
              möglich und zumutbar wäre, die Nutzung im Falle rechtswidriger Inhalte zu verhindern.
            </p>
            <p>
              Der Autor erklärt hiermit ausdrücklich, dass zum Zeitpunkt der Linksetzung die entsprechenden 
              verlinkten Seiten frei von illegalen Inhalten waren. Auf die aktuelle und zukünftige Gestaltung, 
              die Inhalte oder die Urheberschaft der verlinkten/verknüpften Seiten hat der Autor keinerlei 
              Einfluss. Deshalb distanziert er sich hiermit ausdrücklich von allen Inhalten aller verlinkten 
              /verknüpften Seiten, die nach der Linksetzung verändert wurden.
            </p>

            <h3>Urheber- und Kennzeichenrecht</h3>
            <p>
              Der Autor ist bestrebt, in allen Publikationen die Urheberrechte der verwendeten Grafiken, 
              Tondokumente, Videosequenzen und Texte zu beachten, von ihm selbst erstellte Grafiken, 
              Tondokumente, Videosequenzen und Texte zu nutzen oder auf lizenzfreie Grafiken, Tondokumente, 
              Videosequenzen und Texte zurückzugreifen.
            </p>
            <p>
              Alle innerhalb des Internetangebotes genannten und ggf. durch Dritte geschützten Marken- und 
              Warenzeichen unterliegen uneingeschränkt den Bestimmungen des jeweils gültigen Kennzeichenrechts 
              und den Besitzrechten der jeweiligen eingetragenen Eigentümer.
            </p>
          </section>

          <section className="legal-section">
            <h2>Datenschutz</h2>
            <p>
              Sofern innerhalb des Internetangebotes die Möglichkeit zur Eingabe persönlicher oder 
              geschäftlicher Daten (Emailadressen, Namen, Anschriften) besteht, so erfolgt die Preisgabe 
              dieser Daten seitens des Nutzers auf ausdrücklich freiwilliger Basis. Die Nutzung und 
              Bezahlung aller angebotenen Dienste ist - soweit technisch möglich und zumutbar - auch 
              ohne Angabe solcher Daten bzw. unter Angabe anonymisierter Daten oder eines Pseudonyms gestattet.
            </p>
            <p>
              Weitere Informationen finden Sie in unserer <a href="/datenschutz">Datenschutzerklärung</a>.
            </p>
          </section>

          <section className="legal-section">
            <h2>Rechtswirksamkeit</h2>
            <p>
              Dieser Haftungsausschluss ist als Teil des Internetangebotes zu betrachten, von dem aus auf 
              diese Seite verwiesen wurde. Sofern Teile oder einzelne Formulierungen dieses Textes der 
              geltenden Rechtslage nicht, nicht mehr oder nicht vollständig entsprechen sollten, bleiben 
              die übrigen Teile des Dokumentes in ihrem Inhalt und ihrer Gültigkeit davon unberührt.
            </p>
          </section>

          <section className="legal-section">
            <h2>Vereinszweck</h2>
            <p>
              Der EFC Buseck e.V. ist ein gemeinnütziger Verein zur Förderung des Sports, insbesondere 
              der Unterstützung von Eintracht Frankfurt. Unsere Aktivitäten umfassen:
            </p>
            <ul>
              <li>Organisation von Fahrten zu Heim- und Auswärtsspielen</li>
              <li>Förderung der Fangemeinschaft und des Fair Play</li>
              <li>Unterstützung sozialer Projekte im lokalen Umfeld</li>
              <li>Kulturelle und gesellschaftliche Aktivitäten für Mitglieder</li>
            </ul>
          </section>

          <section className="legal-section">
            <h2>Online-Streitbeilegung</h2>
            <p>
              Die Europäische Kommission stellt eine Plattform zur Online-Streitbeilegung (OS) bereit: 
              <a href="https://ec.europa.eu/consumers/odr/" target="_blank" rel="noopener noreferrer">
                https://ec.europa.eu/consumers/odr/
              </a>
            </p>
            <p>
              Unsere E-Mail-Adresse finden Sie oben im Impressum. Wir sind nicht bereit oder verpflichtet, 
              an Streitbeilegungsverfahren vor einer Verbraucherschlichtungsstelle teilzunehmen.
            </p>
          </section>

          <section className="legal-section">
            <h2>Stand der Informationen</h2>
            <p>
              <strong>Letzte Aktualisierung:</strong> 23. August 2025<br/>
              <strong>Verantwortlich für den Inhalt:</strong> Michael Weber (1. Vorsitzender)
            </p>
          </section>
        </div>
      </div>
    </div>
  );
};

export default Imprint;
